import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './NotFound.module.scss';
export const NotFound = () => {
    return (_jsxs("div", { className: classes.notFound, children: [_jsx("div", { className: "fontSize40", "data-testid": "404", children: "404" }), _jsx("div", { "data-testid": "notFoundText", children: "Page not found" })] }));
};
